module.exports = __webpack_public_path__ + "static/media/facilities2.faf8adec.jpg";